import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProductionLineCanvas } from "./ProductionLineCanvas";
import type { MachineDetail } from "@/features/lines/hooks";

interface Props {
  open: boolean;
  onClose: () => void;
  lineId: string;
  lineName: string;
  onMachineClick?: (m: MachineDetail) => void;
}

export function CanvasFullscreenModal({ open, onClose, lineId, lineName, onMachineClick }: Props) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[60]"
      aria-modal="true"
      role="dialog"
      aria-label={`Fluxo · ${lineName}`}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- backdrop click-outside-to-close; Escape gerenciado no modal */}
      <div className="absolute inset-0 bg-background/80" onClick={onClose} />
      <div className="absolute inset-4 flex flex-col rounded-lg border bg-card shadow-2xl">
        <header className="flex items-center justify-between border-b px-4 py-2">
          <h2 className="text-base font-semibold">Fluxo · {lineName}</h2>
          <Button variant="ghost" size="icon" aria-label="Fechar" onClick={onClose}>
            <X className="h-4 w-4" />
          </Button>
        </header>
        <div className="flex-1 p-2">
          <ProductionLineCanvas
            lineId={lineId}
            mode="display"
            onMachineClick={onMachineClick}
            height="100%"
          />
        </div>
      </div>
    </div>,
    document.body
  );
}
